export default function getActiveModalSelector(state: Store): number {
    return state.modal.activeModal;
}
